// logo-switcher.js
// Handles the switching between white and black logos in the header

document.addEventListener('DOMContentLoaded', function() {
  initLogoSwitcher();
  
  // In case of dynamic section loads (Shopify)
  document.addEventListener('shopify:section:load', function() {
    initLogoSwitcher();
  });
});

function initLogoSwitcher() {
  // Get references to all logo elements
  const whiteLogos = document.querySelectorAll('.header__heading-logo--white');
  const blackLogos = document.querySelectorAll('.header__heading-logo--black');
  
  if (!whiteLogos.length && !blackLogos.length) return;
  
  // Always mark logos to prevent default filter application
  [...whiteLogos, ...blackLogos].forEach(logo => {
    logo.setAttribute('data-preserve-logo-color', 'true');
  });
  
  // Get references to the drawer and header elements for mobile
  const menuDrawerDetails = document.querySelector('#Details-menu-drawer-container');
  const headerWrapper = document.querySelector('.header-wrapper');
  
  // Get references to mega menu elements for desktop
  const megaMenus = document.querySelectorAll('.mega-menu');
  
  // Function to update the visibility of logos based on menu state
  function updateLogoVisibility() {
    if (!headerWrapper) return;
    
    // Check for pages where original logo logic should remain
    const isOnHomepage = document.body.classList.contains('template-index');
    const isOnProduct = document.body.classList.contains('template-product');
    const isOnCollection = document.body.classList.contains('template-collection');
    if (isOnHomepage || isOnProduct || isOnCollection) {
      const isDrawerOpen = headerWrapper.classList.contains('drawer-open');
      const isMegaMenuOpen = headerWrapper.classList.contains('mega-menu--open');
      
      // When any menu is open, show black logo
      if (isDrawerOpen || isMegaMenuOpen) {
        whiteLogos.forEach(logo => logo.style.display = 'none');
        blackLogos.forEach(logo => logo.style.display = 'block');
      } else {
        // When all menus are closed, show white logo
        whiteLogos.forEach(logo => logo.style.display = 'block');
        blackLogos.forEach(logo => logo.style.display = 'none');
      }
    } else {
      // On all other pages, always show black logo
      whiteLogos.forEach(logo => logo.style.display = 'none');
      blackLogos.forEach(logo => logo.style.display = 'block');
    }
  }
  
  // Mobile drawer menu observer
  if (menuDrawerDetails) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'open') {
          updateLogoVisibility();
        }
      });
    });
    
    observer.observe(menuDrawerDetails, { attributes: true });
  }
  
  // Desktop mega menu observers
  megaMenus.forEach(menu => {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'open') {
          updateLogoVisibility();
        }
      });
    });
    
    observer.observe(menu, { attributes: true });
  });
  
  // Set initial state
  updateLogoVisibility();
} 